import OrderSellerRemarksFlag from "@/enum/OrderSellerRemarksFlag";
import OrderStatus from "@/enum/OrderStatus";
import OrderExportField from "./enum/Fields";
import TimeType from "./enum/ExportType";
import WaybillPrinted from "./enum/WaybillPrinted";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import mainServerClient from "@/services/http/mainServerClient";
import { PremiumFunctionType } from "@/services/PremiumValidator";
import OrderType from "./enum/OrderType";
import { QueryOrderListParams } from "../../order";
import { PagedResult } from "../../types";
import OrderItemStyle from "./enum/OrderItemStyle";

export enum OrderExportTaskStatus {
    COMPLETED = "COMPLETED",
    ERROR = "ERROR",
    PENDING = "PENDING",
    RUNNING = "RUNNING",
}

export interface OrderExportParams {
    fields: OrderExportField[];

    needExportRefundOrderItems?: boolean;

    needExportingOrderItems: boolean;

    orderType: OrderType;

    orderStatus: OrderStatus[];

    sellerFlags: OrderSellerRemarksFlag[];

    shopIds: number[];

    /**
     * 代理商
     */
    retailerShopId?: number;

    timeEnd: string;

    timeStart: string;

    exportType: TimeType;

    waybillPrinted: WaybillPrinted;

    captchaKey?: string;

    captchaText?: string;

    orderItemStyle: OrderItemStyle;

    supplierIds?: number[];
}

export interface OrderExportResult extends OrderExportParams {
    containsAllFlag: boolean;
    dateCreated: string;
    id: number;
    status: OrderExportTaskStatus;
    url?: string;
    error?: string;
    opUserName: string;
    clientIp: string;
    /** 导出记录所属的店铺(哪个店铺的用户操作的导出，导出记录属于那个店铺) */
    shopId: number;
    hasDownloadUrl: boolean;
}

/**
 * 创建导出运单号任务
 * 注意使用时，必须是同节点的店铺
 */
export function orderExport(params: OrderExportParams) {
    return mainServerClient.post("/order_export_task/create", params, {
        pathPremiumValidator() {
            return {
                type: PremiumFunctionType.EXPORT_ALL_SEARCHED_ORDER_INFO,
            };
        },
    });
}

interface GetOrderExportListParams {
    /** 任务 ID，为空时，默认查所有订单导出任务。 */
    ids?: string[];
    pageNo: number;
    pageSize: number;
}

/**查询导出任务 */
export function getOrderExportList(params: GetOrderExportListParams): Promise<PagedResult<OrderExportResult>> {
    return mainServerClient.get("/order_export_task/list", params);
}

export interface OrderExportDownloadParams {
    mergeSplitStatus: OrderMergeSplitStatus;

    orderId: number;

    orderStatus: OrderStatus;

    selectedOrderItemOriginalIds: string[];
}

interface OrderListExportResult {
    errorMsg: string;
    status: OrderExportTaskStatus;
    taskId: string;
    url: string;
}

export function getOrderExportTaskProcess(taskId: string): Promise<OrderListExportResult> {
    return mainServerClient.get("/order_export/get_generate_task", { taskId });
}

export interface SelectedOrderTableOrderExportParams {
    captchaKey?: string;
    captchaText?: string;
    fields?: OrderExportField[];
    orderItemStyle?: OrderItemStyle;

    ordersMap: {
        [shopId: number]: OrderExportDownloadParams[];
    };
}

export interface SearchAllOrderTableOrderExportParams {
    captchaKey?: string;
    captchaText?: string;
    fields?: OrderExportField[];
    orderItemStyle?: OrderItemStyle;
    queryParamsMap: {
        [shopId: number]: QueryOrderListParams;
    };
}

export type OrderTableOrderExportParams = SelectedOrderTableOrderExportParams | SearchAllOrderTableOrderExportParams;

/** 订单列表使用 */
export function submitOrderExportTask(params: OrderTableOrderExportParams): Promise<OrderListExportResult> {
    return mainServerClient.post("/order_export/submit_task", params);
}

export interface OrderExportFieldsStatus {
    /**
     * 是否勾选
     */
    checked?: boolean;
    /**
     * 导出字段
     */
    field?: OrderExportField;
}

/** 获取当前公司订单导出字段 */
export function getOrderExportFieldsStatus(): Promise<OrderExportFieldsStatus[]> {
    return mainServerClient.get("/stats/setting/v2/order_export_fields");
}

/** 保存订单导出字段保存订单导出字段 */
export function savaOrderExportFieldsStatus(orderExportFieldsStatus: OrderExportFieldsStatus[]): Promise<void> {
    return mainServerClient.post("/stats/setting/v2/save_order_export_fields", { orderExportFieldsStatus });
}

/** 获取订单导出任务下载链接 */
export function getOrderExportDownloadUrl(taskId: number): Promise<string> {
    return mainServerClient.get<string>("/order_export_task/download_url", { taskId });
}
